import React, { useEffect, useState } from 'react';
import {
  DetailsContainer,
  Image,
  ImageContainer,
  ProfileCardContainerPL,
  ProfileImageStyled,
  ProfileLine,
  ProfileTitle,
} from '../../../../atoms/dashboard/personalDashboard.styles';
import Avatar from 'react-avatar';
import { useRecoilValue } from 'recoil';
import { Current_User } from '../../../../../recoil/recoil';

const ProfileCard = data => {
  const [profileData, setProfileData] = useState(null);
  const [imageSrc, setImageSrc] = useState(null);
  const [currentAssignedUser, setCurrentAssignedUser] = useState(null);
  const currentUser = useRecoilValue(Current_User);
  let imageBase64ToImage;

  useEffect(async () => {
    let timeoutId;

    if (!!data && data != null && data != undefined && currentUser != null) {
      setProfileData(data.data);

      if (data?.data?.photo != null) {
        imageBase64ToImage = 'data:image/jpg;base64,' + data?.data?.photo;
        setImageSrc(imageBase64ToImage);
      }
    }

    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      let user = JSON.parse(localStorage.getItem('selectedUser'));
      setCurrentAssignedUser(user);
    }, 3000);
  }, [data, currentUser]);

  const getAvatarName = userName => {
    const nameArray = userName?.split(' ');
    const formattedName = nameArray && nameArray[0] + ' ' + nameArray[nameArray.length - 1];
    return formattedName;
  };

  return (
    profileData != null && (
      <ProfileCardContainerPL>
        <ImageContainer>
          <Image>
            {imageSrc != null && <ProfileImageStyled src={imageSrc} alt=" " />}

            {imageSrc == null && (
              <Avatar name={getAvatarName(profileData?.displayName)} size="100" round={true} />
            )}
          </Image>
        </ImageContainer>
        <DetailsContainer>
          <ProfileTitle>{profileData.displayName}</ProfileTitle>
          <ProfileLine>{currentUser.role}</ProfileLine>

          {currentUser.role == 'GCSP' && currentAssignedUser != null && (
            <ProfileLine>{currentAssignedUser?.name}</ProfileLine>
          )}

          <ProfileLine>
            {profileData?.officeLocation == null
              ? profileData?.country
              : profileData?.country == null
                ? profileData?.officeLocation
                : `${profileData?.officeLocation}, ${profileData?.country}`}
          </ProfileLine>

          {/* {currentUser.role == 'PL' && (
            <ProfileLine>Consulting, Business Consulting, Technology Risk</ProfileLine>
          )} */}
        </DetailsContainer>
      </ProfileCardContainerPL>
    )
  );
};

export default ProfileCard;
